<div class="w-full">
  <div class="flex align-items-center flex-wrap mb-4 mt-4">
    <div class="text-800 text-2xl font-medium mr-4">{{ 'AXIAL_PERCENTILE_TITLE' | translate }}</div>
    @if(percentage){

    @if(!ageOutOfBounds){
    <div class="border-round-2xl px-2 py-1"
      [ngStyle]="{ backgroundColor: getPercentageColor(percentage!), color: getTextColor(percentage!) }">
      {{ percentagePercentile }}
    </div>
    }@else {
    <div class="border-round-2xl px-2 py-1"
      [ngStyle]="{ backgroundColor: getPercentageColor(99), color: getTextColor(99) }">
      {{ percentagePercentile }}
    </div>
    }
    }
    @else(){
    <div class="border-round-2xl px-2 py-1"
      [ngStyle]="{ backgroundColor: getPercentageColor(99), color: getTextColor(99) }">
      {{ 'NO_PERCENTILE_DATA_LATEST_VISIT' | translate }}
    </div>
    }
  </div>
  @if (percentage) {
  <div class="">{{ axialPercentileDescription }}</div>
  <!--DISCLAIMER-->
  <div class="mb-4 mt-2 text-gray-400 text-sm">*{{'TAKEN_FROM_MOST_MYOPIC_EYE'|translate}}</div>
  }

  <app-axial-graph [axialCalcResponse]="axialCalcResponse" [treatmentCalcResponse]="treatmentCalcResponse"
    [ethnicity]="ethnicity" [mostMyopicEyeSide]="axialCalcResponse.mostMyopicEye">
  </app-axial-graph>
</div>